import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const TextButton = styled(Button)(({ theme }) => ({
  gap: '10px',
  textTransform: 'none',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.primary,
  borderColor: theme.palette.divider,
  letterSpacing: '1.25px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.disabled,
  },
  '&:active': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.disabled,
  },
}));

export default TextButton;
